export default "/assets/images/problem-solved-05.dc43845819e519e8.png";